<template>
  <div><print-exit-label :copy="$route.params.number" @print-ready="print" :products.sync="product" :sale.sync="sale" /></div>
</template>

<script>
import PrintExitLabel from '@/views/pos/pdf/PrintExitLabel.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ExitLabel',

  components: {
    PrintExitLabel
  },

  data() {
    return {
      printLabel: false,
      product: []
    }
  },

  async created() {
    const productsIds = this.$route.params.productIds.split('-')

    // get sale record
    await this.getSaleById(this.$route.params.saleId)

    // sale items
    const saleItems = this.salesItems.filter(r => productsIds.includes(String(r.product.id)))

    this.product = saleItems.map(e => {
      const saleItemsReturn = this.sale.sales_return ? this.sale.sales_return.salesItemsReturn.find(r => r.productId === Number(e.product.id)) : { return_qty: 0 }
      return {
        ...e.product,
        batchNumber: e.batch && e.batch.batch_number,
        weight_type: e.weight_type,
        quantity: e.sales_qty - ((saleItemsReturn && saleItemsReturn.return_qty) || 0)
      }
    })

    this.$nextTick(() => {
      window.print()
    })
  },

  computed: {
    ...mapState('pos', ['sale', 'salesItems', 'salesPayments', 'productIds'])
  },

  methods: {
    ...mapActions('pos', { getSaleById: 'getSaleById' }),
    print() {
      // window.print()
    }
  }
}
</script>
